import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import { useSelector } from "react-redux";
import { ImageURL } from "./config/config";
import { handleChefNav, handleChefNavHref } from "./../utility/commonFunctions"

const group = ImageURL + "assets/images/Group 92.png";
const logo1 = ImageURL + "assets/images/logo4.png";

const Header = () => {
  const navigate = useNavigate();
  const LoginData = useSelector((state) =>
    state.login.data && state.login.data.chefDetails ? state.login.data : {}
  );
  const SignupData = useSelector((state) =>
    state.Signup.data ? state.Signup.data : {}
  );

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const logout = (e) => {
    localStorage.clear();
    handleChefNav(e,"")

  };
  let { pathname } = useLocation();

  return (
    <>
      <header className="topHeader" id="fixed-header">
        <div className="container">
          <div>
            <nav className="navbar navbar-expand-lg ">
              <div className="navbar-inner-box">
                <div className="nav-L">
                  <NavLink
                    className="navbar-brand desktop-view-logo"
                    to={handleChefNavHref("/")}
                    style={{ cursor: "pointer" }}
                    onClick={e => handleChefNav(e, "")}
                  >
                    <img src={group} />
                  </NavLink>

                  <NavLink
                    className="navbar-brand mob-logo-view "
                    style={{ display: "none", cursor: "pointer" }}
                    to={handleChefNavHref("/")}
                    onClick={e => handleChefNav(e, "")}
                  >
                    <img src={logo1} />
                  </NavLink>
                </div>
              </div>
            </nav>
          </div>
        </div>
        <div className="nav-R">
          <button
            className="navbar-toggler"
            type="button"
            onClick={handleClickOpen}
          >
            <span className="navbar-toggler-icon">
              <i className="ri-menu-line"></i>
            </span>
          </button>
          <div
            className={
              open
                ? "collapse navbar-collapse show"
                : "collapse navbar-collapse"
            }
            id="navbarSupportedContent"
          >
            <a
              style={{ cursor: "pointer" }}
              className="closebtn"
              id="close"
              onClick={handleClose}
            >
              ×
            </a>
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a
                  className={
                    pathname === "/about-us" ? "nav-link active" : "nav-link"
                  }
                  onClick={e => { handleChefNav(e, "about-us"); handleClose(); }}
                  aria-current="page"
                  href={handleChefNavHref("about-us")}
                  style={{ cursor: "pointer" }}
                >
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={
                    pathname === "/catering"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  aria-current="page"
                  onClick={e => { handleChefNav(e, "catering"); handleClose(); }}
                  href={handleChefNavHref("catering")}
                  style={{ cursor: "pointer" }}
                >
                  Catering Services
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={
                    pathname === "/private-chef-experience"
                      ? "nav-link active"
                      : "nav-link"
                  }
                  aria-current="page"
                  onClick={e => { handleChefNav(e, "private-chef-experience"); handleClose(); }}
                  href={handleChefNavHref("private-chef-experience")}
                  style={{ cursor: "pointer" }}
                >
                  Private Chef
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={
                    pathname === "/contact-us" ? "nav-link active" : "nav-link"
                  }
                  aria-current="page"
                  onClick={e => { handleChefNav(e, "contact-us"); handleClose(); }}
                  href={handleChefNavHref("contact-us")}
                  style={{ cursor: "pointer" }}
                >
                  Contact Us
                </a>
              </li>
              {LoginData.token || SignupData.token ? (
                <li className="nav-item" onClick={(e) => logout(e)}>
                  <a className="nav-link " aria-current="page">
                    Logout
                  </a>
                </li>
              ) : (
                <li className="nav-item">
                  <NavLink
                    className={
                      pathname === "/login" ? "nav-link active" : "nav-link"
                    }
                    // onClick={e => { handleChefNav(e, "login"); handleClose(); }}
                    aria-current="page"
                    to="login"
                    style={{ cursor: "pointer" }}
                  >
                    Login as Chef
                  </NavLink>
                  <NavLink
                    className={
                      pathname === "/signup" ? "nav-link active" : "nav-link"
                    }
                    aria-current="page"
                    // onClick={e => { handleChefNav(e, "signup"); handleClose(); }}
                    to="signup"
                    style={{ cursor: "pointer" }}
                  >
                    Sign Up as Chef
                  </NavLink>
                </li>
              )}
            </ul>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
